import { ActualCostStatusIndicator } from '@/features/financials/components/common/ActualCostStatusIndicator';
import { useVisibleActualCost } from '../context/VisibleItemFinancialsContext';
import type { ItemsTableRow } from '../types';
import { OrgCurrencyCell } from './OrgCurrencyCell';

export const ActualCostCell = ({ row }: { row: ItemsTableRow }) => {
  const entry = useVisibleActualCost(row.id);
  if (!entry) return null;

  // Not ActualCostAmount: OrgCurrencyCell's OverflowTooltip renders a `w-full` div that needs a
  // definite-width flex ancestor to measure overflow against — nesting it in ActualCostAmount's
  // auto-sized inline-flex span would break that measurement.
  return (
    <div className="flex w-full items-center justify-end gap-1.5">
      <ActualCostStatusIndicator status={entry.status} />
      <OrgCurrencyCell amount={entry.value} />
    </div>
  );
};
